import { useEffect, useState } from "react";
import { Cascader } from "antd";

import SearchInBoard from "../SearchInBoard";
import FooterInBoard from "../FooterInBoard";
import { BoardType } from "../../type";

import styles from "../../style/index.module.scss";
const expandIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.01946 6.9999L4.23963 3.22007C4.01182 2.99226 4.01182 2.62292 4.23963 2.39511L4.36337 2.27137C4.59118 2.04356 4.96052 2.04356 5.18833 2.27137L9.91687 6.9999L5.18833 11.7284C4.96052 11.9562 4.59118 11.9562 4.36337 11.7284L4.23963 11.6047C4.01182 11.3769 4.01182 11.0075 4.23963 10.7797L8.01946 6.9999Z'
      fill='#646566'
    />
  </svg>
);
const Board = ({
  options,
  value,
  onChange,
  onCloseDropdown,
  boardClearText,
  boardApplyFiltersText,
  searchBoardPlaceholder,
  visibleSearch = true,
  searchValue,
  setSearchValue,
  setSelectValue,
  selectValue,
  onMultipleChange,
  realTimeRefresh,
  cascaderPanelProps,
  total,
  setTotal,
  type
}: BoardType) => {
  const customOptions = options.map((item) => ({
    ...item,
    label:
      item.sort_order <= 4 ? (
        <span style={{ display: "inline-block", width: "100%", minWidth: "800px !important" }}>
          <span>{item.label}</span>
          <span className={styles.hotLabel}>Hot</span>
        </span>
      ) : (
        item.label
      )
  }));

  return (
    <div style={{ padding: 12 }} id='multiSelectWrapper'>
      {visibleSearch && (
        <SearchInBoard
          options={options}
          setValue={setSelectValue}
          searchBoardPlaceholder={searchBoardPlaceholder}
          searchValue={searchValue}
          onChange={onChange}
          value={value}
          setTotal={setTotal}
          realTimeRefresh={realTimeRefresh}
          setSearchValue={setSearchValue}
          type={type}
        />
      )}
      {visibleSearch && <div style={{ height: 14 }} />}

      <Cascader.Panel
        multiple
        options={customOptions}
        value={selectValue}
        onChange={onMultipleChange}
        showCheckedStrategy='SHOW_CHILD'
        className={styles.overridePanel}
        expandTrigger='hover'
        expandIcon={expandIcon}
        {...cascaderPanelProps}
      />
      {!realTimeRefresh && (
        <FooterInBoard
          value={selectValue}
          total={total}
          onChange={onChange}
          setValue={setSelectValue}
          setSearchValue={setSearchValue}
          onCloseDropdown={onCloseDropdown}
          boardClearText={boardClearText}
          boardApplyFiltersText={boardApplyFiltersText}
          realTimeRefresh={realTimeRefresh}
        />
      )}
    </div>
  );
};

export default Board;
